import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'

import { notificationsApi } from './notifications.api'

export const NOTIFICATIONS_PAGE_SIZE = 50
/** Only notifications from the last N days are shown (matches iOS). */
export const NOTIFICATIONS_WINDOW_DAYS = 30

export const notificationQueryKeys = {
  all: ['notifications'] as const,
  list: () => [...notificationQueryKeys.all, 'list'] as const,
  unreadCount: () => [...notificationQueryKeys.all, 'unread-count'] as const,
  settings: () => [...notificationQueryKeys.all, 'settings'] as const,
}

export const notificationQueries = {
  list: () =>
    infiniteQueryOptions({
      queryKey: notificationQueryKeys.list(),
      queryFn: ({ pageParam }) =>
        notificationsApi.getNotifications(
          NOTIFICATIONS_PAGE_SIZE,
          pageParam,
          NOTIFICATIONS_WINDOW_DAYS,
        ),
      initialPageParam: 0,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.notifications.length < NOTIFICATIONS_PAGE_SIZE
          ? undefined
          : allPages.reduce((count, page) => count + page.notifications.length, 0),
    }),

  unreadCount: () =>
    queryOptions({
      queryKey: notificationQueryKeys.unreadCount(),
      queryFn: () => notificationsApi.getUnreadCount(),
      refetchInterval: 30_000,
    }),

  settings: () =>
    queryOptions({
      queryKey: notificationQueryKeys.settings(),
      queryFn: () => notificationsApi.getSettings(),
    }),
}
